export interface AIAnswer { question: string; answer: string; }
export interface AIAnswerContent { badge?: string; heading: string; subheading?: string; answers: AIAnswer[]; }
interface Props { content: AIAnswerContent; }

export default function AIAnswerBlock({ content }: Props) {
  return (
    <section className="w-full bg-[#111111] py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Section label */}
        <div className="flex items-center gap-3 mb-6">
          <div className="h-px w-10 bg-gold"></div>
          <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-gold">{content.badge ?? 'AI & Voice Search'}</span>
        </div>

        {/* Heading row */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 pb-12 border-b border-white/8">
          <div className="lg:col-span-6">
            <h2 className="font-serif text-white font-semibold leading-tight" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.2rem)' }}>
              {content.heading}
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            {content.subheading && (
              <p className="font-sans text-white/40 text-sm leading-relaxed">{content.subheading}</p>
            )}
          </div>
        </div>

        {/* Q&A Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {content.answers.map((item, i) => (
            <div key={i} className="relative overflow-hidden rounded-2xl border border-white/8 bg-white/4 p-8 hover:border-gold/25 hover:bg-white/6 transition-all">
              {/* Decorative number */}
              <span className="absolute -top-3 -right-1 font-serif font-bold text-white/5 select-none pointer-events-none leading-none" style={{ fontSize: '7rem' }} aria-hidden="true">
                {i + 1}
              </span>

              <div className="flex items-start gap-3 mb-5">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gold/20 shrink-0 mt-0.5">
                  <i className="ri-question-mark text-gold text-xs"></i>
                </div>
                <h3 className="font-sans text-white font-semibold text-sm leading-snug pr-10">{item.question}</h3>
              </div>

              <div className="pl-9">
                <div className="h-px w-8 bg-gold/35 mb-4"></div>
                <p className="font-sans text-white/50 text-sm leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <span className="inline-flex items-center gap-2 font-sans text-[9px] text-white/18 tracking-[0.25em] uppercase">
            <i className="ri-robot-line text-xs"></i> Structured for Google AI Overviews, Voice Search &amp; AI Assistants
          </span>
        </div>
      </div>
    </section>
  );
}
